export default {
  teacher: {
    id: "",
    code: "",
    facultyId: "",
    curriculumId: "",
    prefixId: "",
    firstNameLocal: "",
    lastNameLocal: "",
    firstNameEng: "",
    lastNameEng: "",
    availableTime: "",
    telephone: "",
    email: "",
    picturePath: "",
    socialMedia: "",
    isSpecialTeacher: null,
    isActive: null,
    userId: "",
  },
  teachers: [],
  teachersDdl: [],
  processing: false,
  error: null,
  success: null,
}

